import { Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useRef } from "react";
import AddIcon from "@mui/icons-material/Add";
import { showWarningSnackbar } from "../../../components/snackBar/snakbar";
import { useState } from "react";
import Attachment from "../../NewFigma/AddCustomer/attachment";
import theme from "../../../styles/Themecolors";
import { useThemes } from "../../../components/Theme/theme";
import CustomTooltip from "../../../components/CustomTooltip";

function ItemAttachment({
  attachments,
  setAttachments,
  path,
  setInitialAttachments,
  itemData,
  params,
  data,
  setDocuments,
}) {
  const imageRef = useRef();
  function handleTextKeyDown(
    e,
    name,
    currentId,
    nextId,
    required,
    warMsg,
    prevID
  ) {
    if (e.key === "Tab" && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey)) {
      if (required && e.target.value === "") {
        e.preventDefault();
        e.stopPropagation();

        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  const handleFileChange = (event) => {
    const files = event.target.files;
    const allowedTypes = [
      "application/msword",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];

    let allFilesValid = true;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!allowedTypes.includes(file.type)) {
        showWarningSnackbar("This format is not allowed");
        allFilesValid = false;
        break;
      }
    }

    if (allFilesValid) {
      setAttachments((currentAttachments) => {
        if (attachments.length + files.length > 6) {
          showWarningSnackbar("You cannot add more than 6 attachments");
          return currentAttachments;
        }

        const newAttachments = Array.from(files).map((file, i) => ({
          attachmentid: currentAttachments.attachmentid
            ? currentAttachments.attachmentid
            : Date.now() + file.name,
          imagename: currentAttachments.imagename
            ? currentAttachments.imagename
            : path + "${id}/" + Date.now() + file.name,
          expiredtimestamp: 0,
          documentname: file.name,
          type: currentAttachments.type ? currentAttachments.type : file.type,
          imageurl: currentAttachments.imageurl
            ? currentAttachments.imageurl
            : URL.createObjectURL(file),
          file,
        }));

        const filteredNewAttachments = newAttachments.filter(
          (newAttachment) =>
            !currentAttachments.some(
              (attachment) =>
                attachment.documentname === newAttachment.documentname
            )
        );

        return [...currentAttachments, ...filteredNewAttachments];
      });
    } else {
      // Optionally clear the file input if invalid file detected
      event.target.value = ""; // This resets the file input
    }

    if (imageRef.current) {
      imageRef.current.value = "";
    }
  };
  console.log(attachments, "attach");
  const updateAttachmentName = (id, newName) => {
    console.log(id, newName, "newName");
    setAttachments(
      attachments.map((attachment) =>
        attachment.attachmentid === id
          ? { ...attachment, documentname: newName }
          : attachment
      )
    );
  };
  function getItemAttachment(itemData) {
    if (itemData?.relateditemimages?.length > 0) {
      let items = [];
      itemData?.relateditemimages.map((item, ind) => {
        if (item.documentname !== null) {
          items.push({
            slNo: "",
            attachmentid: item.attachmentid,
            documentname: item.documentname,
            imagename: item.imagename,
            action: "",
            imageurl: item.imageurl,
            type: item?.type,
          });
        }
      });
      setAttachments([...items]);
      setDocuments([...items]);
      setInitialAttachments([...items]);
    }
  }
  const { theme } = useThemes();
  useEffect(() => {
    getItemAttachment(itemData);
  }, [itemData]);
  return (
    <Grid
      item
      container
      style={{
        justifyContent: { xs: "center", lg: "flex-start" },
      }}
    >
      <Grid item lg={1} xs={12}>
        <Typography
          sx={{
            fontWeight: "bold",
            padding: "6px",
            color: data?.itemName ? theme?.palette?.TmId.id.toString().includes("9")
            ? "white"
            : "black" : "gray", // Change color when disabled
          }}
          variant="h2"
        >
          IMAGES
        </Typography>
      </Grid>
      <Grid lg={3} xs={12} sx={{ ml: "3px", mb: "5px" }}>
        {/* <div
          style={{outline:"none"}}
          id="fileInput"
          tabIndex="0"> */}
        <input
          tabIndex="0"
          ref={imageRef}
          type="file"
          id="fileInput"
          onChange={handleFileChange}
          multiple
          onKeyDown={(e) => {
            const warMsg = "";
            const name = "fileInput";
            const currentId = "fileInput";
            const nextId = "save";
            const prevID = "remarks";
            const required = false;

            handleTextKeyDown(
              e,

              name,
              currentId,
              nextId,
              required,
              warMsg,
              prevID
            );
          }}
          style={{ display: "none", outline: "none" }}
          accept="
        application/msword,
        application/pdf,
        application/vnd.openxmlformats-officedocument.wordprocessingml.document,
        application/vnd.ms-excel,
        application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
        application/vnd.ms-powerpoint,
        application/vnd.openxmlformats-officedocument.presentationml.presentation,
        image/jpeg,
        image/png
      "
        />
        {params?.view !== true && (
          <CustomTooltip title="Rolling out soon" placement="top">
            <span>
              <Button
            onClick={() => imageRef?.current?.click()}
            size="small"
            variant="contained"
            id="Button"
            // disabled={data?.itemName === "" ? true : false}
            disabled={true}
            sx={{ fontSize: "12px" }}
            disableRipple={false}
          >
            <AddIcon fontSize="15px" />
            {" ADD IMAGES"}
            {attachments.length > 0 && (
              <span style={{ color: "white" }}>
                {"\xa0" + `(${attachments.length} out of 6)`}
              </span>
            )}
          </Button>
            </span>
          </CustomTooltip>
          
        )}
        {/* </div> */}
      </Grid>
      <Grid item lg={12}>
        <Attachment
          view={params?.view}
          attachments={attachments}
          setAttachments={setAttachments}
          updateAttachmentName={updateAttachmentName}
        />
      </Grid>
    </Grid>
  );
}

export default ItemAttachment;
